<template>
  <div>
    <h2>我的关注</h2>
    <a-divider></a-divider>
    <a-row type="flex" :gutter="[24, 24]">
      <a-col v-for="(item, index) in studentlist" :key="index" :span="8">
        <a-card class="user-card">
          <a-row>
            <a-col :span="6">
              <a-avatar
                shape="square"
                class="avatar"
                :size="40"
                :src="item.avatar?item.avatar_url:'/img/avatar.png'"
              />
            </a-col>
            <a-col :span="18">
              <h2 class="name">
                {{ item.nickname || item.realname || item.username }}
              </h2>
              <p>签名：<j-ellipsis :value="item.sign" :length="20" /></p>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
    <a-pagination
      @change="pageChange"
      :current="ipagination.current"
      :pageSize="ipagination.pageSize"
      :pageSizeOptions="ipagination.pageSizeOptions"
      :showTotal="ipagination.showTotal"
      :total="ipagination.total"
      showQuickJumper
    />
  </div>
</template>

<script>
import "@/assets/less/animation.css";
import { getAction } from "@/api/manage";
import JEllipsis from "@/components/jeecg/JEllipsis";
export default {
  components: {
    JEllipsis,
  },
  data() {
    return {
      studentlist: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条";
        },
        showQuickJumper: true,
        total: 0,
      },
      queryParam: {},
    };
  },
  created() {
    this.pageChange(1,20)
  },
  methods: {
    pageChange(page, pageSize) {
      this.studentlist = [];
      this.ipagination.current = page;
      this.queryParam.pageNo = this.ipagination.current;
      this.queryParam.pageSize = 20;
      this.ipagination.pageSize = 20;
      this.getStudentList();
    },
    getStudentList() {
      getAction("/sys/user/myAttentionUser", this.queryParam).then((res) => {
        if (res.success) {
          this.ipagination.total = res.result.total;
          this.studentlist = res.result.records;
        }
      });
    },
    toUserInfo(info) {
      this.$router.push("/friend/detail?id=" + info.userId);
    },
  },
};
</script>

<style lang="less" scoped>
.user-card {
  border: none;
  /deep/.ant-card-body {
    width: 275px;
    height: 100px;
    padding: 10px;
    overflow: hidden;
    border-radius: 10px;
    box-shadow: 0px 3px 6px #00000039;
    .name {
      font-weight: bold;
      color: #555;
      text-decoration: none;
      font-size: 14px;
    }
  }
}

.ant-pagination {
  text-align: center;
  margin-top: 40px;
}
</style>